import React, { useReducer, useContext } from "react";
import { teamCoachPoolReducer as reducer } from "../reducers/teamCoachPoolReducer";
import { teamCoachPoolActions as actions } from "../actions/teamCoachPoolActions";

const teamCoachPoolContext = React.createContext();

const TeamCoachPoolContext = ({ team, children }) => {
  const initialValue = {
    team: team,
    coaches: null,
  };

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <teamCoachPoolContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </teamCoachPoolContext.Provider>
  );
};

export const useTeamCoachPoolContext = () =>
  React.useContext(teamCoachPoolContext);
export default TeamCoachPoolContext;
